export default function addIfNotInList(list = [], item, toFront = false) {
    if (!list.includes(item)) {
        if (toFront) {
            return list.unshift(item);
        }
        return list.push(item);
    }
}
